import * as R from 'ramda';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// helpers/constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
// hooks
import { useGetServiceVendorsByType } from '../../../hooks';
// feature configs
import { setServiceVendorOptions } from '../actions';
import { makeSelectServiceVendorOptions } from '../selectors';
//////////////////////////////////////////////////

const ServiceVendorTableCell = ({ serviceVendorGuid, serviceVendorName }) => {
  const dispatch = useDispatch();

  const storedServiceVendorOptions = useSelector(makeSelectServiceVendorOptions);

  const serviceVendorOptions = useGetServiceVendorsByType({
    createOptions: true,
    initialValues: storedServiceVendorOptions,
    types: [GC.SERVICE_VENDOR_TYPE_FLEET_SERVICE, GC.SERVICE_VENDOR_TYPE_FLEET_SELF_SERVICE],
    shouldNotGetServiceVendors: G.isOneNotNilOrNotEmpty([serviceVendorName, storedServiceVendorOptions]),
  });

  useEffect(() => {
    if (R.and(G.isNilOrEmpty(storedServiceVendorOptions), G.isNotNilAndNotEmpty(serviceVendorOptions))) {
      dispatch(setServiceVendorOptions(serviceVendorOptions));
    }
  }, [serviceVendorOptions]);

  if (G.isNotNilAndNotEmpty(serviceVendorName)) return serviceVendorName;

  if (G.isNilOrEmpty(storedServiceVendorOptions)) return null;

  const serviceVendor = R.compose(
    R.propOr(null, GC.FIELD_LABEL),
    R.find(R.propEq(serviceVendorGuid, GC.FIELD_VALUE)),
  )(storedServiceVendorOptions);

  return serviceVendor;
};

export default ServiceVendorTableCell;
